import { render, staticRenderFns } from "./RoomProjectHistoryModal.vue?vue&type=template&id=6b18bcf2&"
import script from "./RoomProjectHistoryModal.vue?vue&type=script&lang=js&"
export * from "./RoomProjectHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports